import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["method", "cacheKey"];
import http from 'hub-http/clients/apiClient';
const localCache = new Map();
// 5 minutes
export const DEFAULT_TTL = 1000 * 60 * 5;
function getCacheKey(url, requestOptions) {
  return `${url}-${JSON.stringify(requestOptions)}`;
}
function isExpired(cacheValue) {
  const now = Date.now();
  return cacheValue.ttl < now;
}
function fetchWithCache(url, requestOptions) {
  const key = requestOptions.cacheKey || getCacheKey(url, requestOptions);
  const cachedResponse = localCache.get(key);
  if (cachedResponse) {
    if (!isExpired(cachedResponse)) {
      return Promise.resolve(cachedResponse.response);
    }
    localCache.delete(key);
  }
  const rest = _objectWithoutPropertiesLoose(requestOptions, _excluded);
  return http[requestOptions.method](url, rest).then(response => {
    const now = Date.now();
    localCache.set(key, {
      response,
      ttl: now + DEFAULT_TTL
    });
    return response;
  });
}
function get(url, requestOptions) {
  return fetchWithCache(url, Object.assign({}, requestOptions || {}, {
    method: 'get'
  }));
}
function post(url, requestOptions) {
  return fetchWithCache(url, Object.assign({}, requestOptions || {}, {
    method: 'post'
  }));
}
function wipeAll() {
  localCache.clear();
}
function getByKey(key) {
  return localCache.get(key);
}
function updateCache(key, value) {
  if (!localCache.has(key)) {
    return;
  }
  const now = Date.now();
  localCache.set(key, {
    response: value,
    ttl: now + DEFAULT_TTL
  });
}
const cachedHttp = {
  get,
  post,
  wipeAll,
  updateCache,
  getByKey
};
export default cachedHttp;